import { Dispatch, SetStateAction, createContext } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

type FirebaseUser = firebase.User;

export interface IUserDefaultValue {
  id?: string;
  firebaseUser?: FirebaseUser;
  role?: {
    id: string;
    permissions: string[];
    name: string;
    is_admin: boolean;
  };
  supplier_id?: number;
}

export const userDefaultValue: IUserDefaultValue = {
  id: undefined,
  firebaseUser: undefined,
  role: undefined,
  supplier_id: undefined,
};

export const UserContext = createContext<IUserDefaultValue>(userDefaultValue);

export const SetUserContext = createContext<Dispatch<SetStateAction<IUserDefaultValue>>>(
  () => null
);
